// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"80e0d203","618":"45f0f506"}[chunkId] + ".chunk.js";
};